import axios from 'axios';

// Dynamische API-URL basierend auf der Umgebung
// In der Produktionsumgebung (Docker/Server): Verwende die Backend-URL über den Nginx Proxy Manager
// In der Entwicklungsumgebung: Verwende localhost oder die Umgebungsvariable
const isProduction = process.env.NODE_ENV === 'production';
const API_URL = isProduction 
  ? '/api'  // Relative URL für Proxy-Weiterleitung
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

// Zusätzliche Debugging-Informationen
console.log('Environment:', process.env.NODE_ENV);
console.log('Using API URL:', API_URL);
console.log('Window location:', window.location.href);
console.log('Is Production:', isProduction);

class AuthService {
  async login(username, password) {
    try {
      console.log('Login attempt to:', `${API_URL}/auth/login`);
      console.log('Login credentials:', { username, password: '***' });
      
      // Konfiguration für CORS
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: false,
        timeout: 30000 // 30 Sekunden Timeout für langsame Netzwerke
      };
      
      console.log('Sending request with config:', JSON.stringify(config));
      
      // Ping-Test zum Backend mit relativer URL
      try {
        const pingUrl = isProduction 
          ? '/api/test'
          : 'http://localhost:3001/api/test';
        
        console.log('Versuche Ping zu:', pingUrl);
        const pingResponse = await axios.get(pingUrl, { timeout: 5000 });
        console.log('Ping response:', pingResponse.data);
      } catch (pingError) {
        console.error('Ping failed:', pingError.message);
        console.error('Ping error details:', pingError.response?.data || pingError.request || pingError);
      }
      
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      }, config);
      
      console.log('Login response status:', response.status);
      console.log('Login response data:', response.data);
      
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        return { success: true, user: response.data.user };
      }
      return { success: false, message: 'Keine gültige Antwort vom Server' };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error details:', error.response?.data || error.message);
      
      // Detaillierte Fehlermeldung
      let errorMessage = 'Ein Fehler ist aufgetreten';
      if (error.response) {
        // Der Server hat mit einem Fehlerstatuscode geantwortet
        errorMessage = `Server-Fehler: ${error.response.status} - ${error.response.data?.message || error.response.statusText}`;
        console.error('Response headers:', error.response.headers);
        console.error('Response data:', error.response.data);
      } else if (error.request) {
        // Die Anfrage wurde gestellt, aber keine Antwort erhalten
        errorMessage = 'Keine Antwort vom Server erhalten. Bitte überprüfen Sie Ihre Internetverbindung.';
        console.error('Request details:', error.request);
        console.error('Request config:', error.config);
      } else {
        // Etwas ist beim Einrichten der Anfrage schief gelaufen
        errorMessage = `Fehler bei der Anfrage: ${error.message}`;
      }
      
      // Zusätzliche Informationen für Debugging
      console.error('API URL:', API_URL);
      console.error('Environment:', process.env.NODE_ENV);
      console.error('Window location:', window.location.href);
      
      return {
        success: false,
        message: errorMessage
      };
    }
  }
  
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }
  
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    return JSON.parse(userStr);
  }
  
  getToken() {
    return localStorage.getItem('authToken');
  }
  
  async isLoggedIn() {
    const token = this.getToken();
    if (!token) return false;
    try {
      const response = await axios.post(`${API_URL}/auth/validate-token`, { token });
      return response.data.success;
    } catch (error) {
      this.logout(); // Token ungültig, ausloggen
      return false;
    }
  }
  
  // Setup Axios Interceptor für automatisches Token-Handling
  setupAxiosInterceptors() {
    axios.interceptors.request.use(
      (config) => {
        const token = this.getToken();
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}

const authService = new AuthService();
authService.setupAxiosInterceptors();
export default authService;
